import {ENDPOINT_CATEGORIES} from "./api_category";
import {ENDPOINT_POSTS} from "./api_post";
import {deleteObject, postObject} from "./api_common";

export const ENDPOINT_CATEGORY_POSTS = '/api/category_posts'

export function postCategoryPost(categoryId, postId) {
    let url = process.env.REACT_APP_API_URL + ENDPOINT_CATEGORY_POSTS

    let postData = {
        category: ENDPOINT_CATEGORIES + '/' + categoryId,
        post: ENDPOINT_POSTS + '/' + postId
    }
    return postObject(url, postData)
}

export function deleteCategoryPost(categoryPostsId) {
    let url = process.env.REACT_APP_API_URL + ENDPOINT_CATEGORY_POSTS + '/' + categoryPostsId
    return deleteObject(url)
}
